<template>
  <div>
    <WsButton001
      @click="$_createPopupOpen()"
    >
      打開popup
    </WsButton001>
    <PopUp
      is-center-column
      overflow-visible
      title="title"
      :pop-up-active="createPopupActive"
      @click="$_createPopupClose()"
    >
      <ValidationObserver ref="formObserver">
        <InputListCard :margin-top="40">
          <div class="input-item">
            <StateInputButton
              v-model="auditAssignment.name"
              required
              title="名稱"
              rules="required"
            />
          </div>
        </InputListCard>
        <WsButton001
          class="mt-40"
          width-stretch
          @click="$emit('createSubmit', auditAssignment)"
        >
          按鈕
        </WsButton001>
      </ValidationObserver>
    </PopUp>
  </div>
</template>

<script>
export default {
  data() {
    return {
      createPopupActive: false,
      auditAssignment: {
        auditId: null,
        name: "",
        date: "",
        auditer: null,
        auditee: null,
        message: false,
      },
    }
  },
  methods: {
    $_createPopupOpen() {
      this.createPopupActive = true;
    },
    $_createPopupClose() {
      this.createPopupActive = false;
    },
  }
}
</script>